import React from 'react';
import ReactDOM from 'react-dom';
import App from './Core/App/App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { AppStorage } from './Core/Basic/storage-service';
import { isChunkLoadError, reloadOnceForStaleChunk } from './Core/Basic/chunk-reload';
import PackageJson from '../package.json';

window._ENV_ = Object.assign(window._ENV_ || {}, { app_version: PackageJson.version });
console.log(window._ENV_, 'window._ENV_');
console.log('is Logged In', AppStorage.isLoggedIn());
if (process.env.NODE_ENV === 'production') {
    console.log(
        '%c⚠️ STOP!',
        'color: red; font-size: 40px; font-weight: bold; font-family: sans-serif;'
    );
    console.log(
        '%cThis feature is for developers. Copy-pasting code or scripts here could expose your account or compromise security. Please do not run scripts unless you fully understand them.',
        'font-size: 16px; color: #333; font-family: sans-serif;'
    );
}
if (AppStorage.isLoggedIn() && window._ENV_.app_version !== AppStorage.getLoggedInUIVersion()) {
    AppStorage.performLogout();
    window.location.href = '/';
}

// Catch stale code-split chunk failures that happen OUTSIDE React's render cycle
// (e.g. a dynamic import() that rejects), which the RouteErrorBoundary can't see.
// If it's a chunk-load error and we successfully triggered a one-time reload,
// swallow the event so the browser doesn't also surface an uncaught error.
window.addEventListener('unhandledrejection', (event) => {
    if (isChunkLoadError(event.reason) && reloadOnceForStaleChunk()) {
        event.preventDefault();
    }
});
window.addEventListener('error', (event) => {
    if (isChunkLoadError(event.error) && reloadOnceForStaleChunk()) {
        event.preventDefault();
    }
});

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
